import { createSelector } from 'reselect';
import { labDetailsDownloadDataSelector } from './lab/selectors';
import { microbiologyDetailsDownloadDataSelector } from './microbiology/selectors';
import { imagingDetailsDownloadDataSelector } from './imaging/selectors';
import { pathologyDetailsDownloadDataSelector } from './pathology/selectors';
import { TestResultCategory } from './types';
import { testWithDetailsDataSelector } from './selectors.common';

/**
 * Download Selectors
 */

export const downloadingTestResultsSelector = createSelector(
  [
    testWithDetailsDataSelector,
    labDetailsDownloadDataSelector,
    microbiologyDetailsDownloadDataSelector,
    imagingDetailsDownloadDataSelector,
    pathologyDetailsDownloadDataSelector
  ],
  (testWithDetails, labData, microbiologyData, imagingData, pathologyData) => {
    const { category, eventId, componentEventIds = [] } = testWithDetails?.testResult || {};

    const eventIds = componentEventIds.join('|');
    const mappedId = eventIds || eventId;

    if (category === TestResultCategory.LAB) {
      return labData[mappedId] === 'pending';
    }

    if (category === TestResultCategory.IMAGING) {
      return imagingData[mappedId] === 'pending';
    }

    if (category === TestResultCategory.PATHOLOGY) {
      return pathologyData[mappedId] === 'pending';
    }

    if (category === TestResultCategory.MICROBIOLOGY) {
      return microbiologyData[mappedId] === 'pending';
    }

    return false;
  }
);
export * from './selectors.common';
